module.exports = "# iterm2\n\n## 安装\n- 在官网下载并安装 http://www.iterm2.com/\n- emmm....安装好像有点简单，安装完了直接就能用了\n\n## 改背景图\n- itrem2->pererence->profiles->window->background-image"


//////////////////
// WEBPACK FOOTER
// ./src/store/mac.md
// module id = 152
// module chunks = 2